<payee-chip-dropdown
  [placeholder]="'Több szűrő'"
  [selected]="hasActiveFilters ? 'Aktív szűrők' : null"
  [displayWith]="displayWith"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="clearAllFilters()"
>
  <div class="more-filters-content">
    @for (filter of filters; track filter.name) {
      <div
        class="filter-item"
        role="button"
        tabindex="0"
        (click)="openFilter(filter)"
        (keydown.enter)="openFilter(filter)"
        (keydown.space)="openFilter(filter); $event.preventDefault()"
      >
        <div class="plus-icon">
          <mat-icon>add</mat-icon>
        </div>
        <span>{{ filter.name }}</span>
      </div>
    }
  </div>

  @if (activeFilter) {
    <div class="sub-filter-content">
      <div class="sub-filter-header">
        <span>{{ activeFilter.name }}</span>
        <button
          class="close-btn"
          (click)="closeFilter()"
        >
          ×
        </button>
      </div>
      <div class="sub-filter-options">
        <ng-container [ngComponentOutlet]="activeFilter.component"></ng-container>
      </div>
    </div>
  }
</payee-chip-dropdown>
